module.exports = __webpack_public_path__ + "img/funny_cat.0f8127e7.jpg";